module.exports = __webpack_public_path__ + "static/img/6.b62c732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Multiriesgo-corporativo/6.png
// module id = EStI
// module chunks = 0